import React from 'react';

import { NavLink } from 'react-router-dom';
import { withRouter } from 'react-router';
import $ from "jquery";

class Form extends React.Component{

    constructor(props){
        super(props);

        this.state = {
            etunimi: '',
            sukunimi: '',
            address: '',
            email: '',
            postinumero: '',
            postitoimipaikka: '',
            puhelinnumero: '',
            nearestHospital: '',
            agreeTerms: false,
            agreeMoreInfo: false,

            valid: {
                all: true,
                etunimi: true,
                sukunimi: true,
                email: true,
                agreeTerms: true,
            }
        }


        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleRules = this.handleRules.bind(this);
        this.handleTerms = this.handleTerms.bind(this);
    }

    handleInputChange(e){
        const target = e.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    handleRules(){
        this.props.onRulesClick();
    }
    handleTerms(){
        this.props.onTermsClick();
    }

    handleSubmit() {
        let valid = true;
        let validState = {
            all: true,
            etunimi: true,
            sukunimi: true,
            email: true,
            agreeTerms: true,
        };

        if (this.state.etunimi.trim() == '') {
            valid = false;
            validState.etunimi = false;
        }

        if (this.state.sukunimi.trim() == '') {
            valid = false;
            validState.sukunimi = false;
        }

        if (this.state.email.trim() == '') {
            valid = false;
            validState.email = false;
            this.setState({valid: {email: false}});
        }

        if (this.state.agreeTerms == false) {
            valid = false;
            validState.agreeTerms = false;
        }

        validState.all = valid;

        this.setState({valid: validState});

        if (valid) {
            

            $.post('/record.php', this.state).done(() => {
                this.setState({
                    etunimi: '',
                    sukunimi: '',
                    address: '',
                    email: '',
                    postinumero: '',
                    postitoimipaikka: '',
                    puhelinnumero: '',
                    nearestHospital: '',
                    agreeTerms: false,
                    agreeMoreInfo: false,
        
                    valid: {
                        all: true,
                        etunimi: true,
                        sukunimi: true,
                        email: true,
                        agreeTerms: true,
                    }
                });
                this.props.history.push('/thankyou');
            }).fail(() => {
                alert('Error, please try again');
            });
        } else {

        }
    }

    render(){
        return(<div className="fullwidth">
            <div className="container-fluid ">
            <article className="container">
                <div className="row">
                    <div className="col-xs-12">
                        <div className="form-heading">
                            <h2>Jes, osallistun leffalippupaketin arvontaan!</h2>
                            <p>
                            Finnkinon leffalippupaketti (4kpl lippuja) arvotaan kaikkien osallistuneiden kesken. <br />Jättämällä alle yhteystietosi, osallistut arvontaan.
                            </p>

                        </div>
                        <hr />
                        <form id="form">
                            <div className="row inputs">
                                <div className="col-xs-4">
                                    <input type="text" name="etunimi" placeholder="Etunimi*" autoComplete="off" value={this.state.etunimi} onChange={this.handleInputChange} className={this.state.valid.etunimi ? '' : 'error'} />
                                </div>
                                <div className="col-xs-4">
                                    <input type="text" name="sukunimi" placeholder="Sukunimi*" autoComplete="off" value={this.state.sukunimi} onChange={this.handleInputChange} className={this.state.valid.sukunimi ? '' : 'error'} />
                                </div>
                                <div className="col-xs-4">
                                    <input type="text" name="address" placeholder="Katuosoite" autoComplete="off" value={this.state.address} onChange={this.handleInputChange} />
                                </div>
                            </div>
                            <div className="row inputs">
                                <div className="col-xs-4">
                                    <input type="text" name="postinumero" placeholder="Postinumero" autoComplete="off" value={this.state.postinumero} onChange={this.handleInputChange} />
                                </div>
                                <div className="col-xs-4">
                                    <input type="text" name="postitoimipaikka" placeholder="Postitoimipaikka" autoComplete="off" value={this.state.postitoimipaikka} onChange={this.handleInputChange} />
                                </div>
                                <div className="col-xs-4">
                                    <input type="email" name="email" placeholder="Sähköpostiosoite*" autoComplete="off" value={this.state.email} onChange={this.handleInputChange} className={this.state.valid.email ? '' : 'error'} />
                                </div>
                            </div>
                            <div className="row inputs">
                                <div className="col-xs-4">
                                    <input type="text" name="puhelinnumero" placeholder="Puhelinnumero*" autoComplete="off" value={this.state.puhelinnumero} onChange={this.handleInputChange} />
                                </div>
                                <div className="col-xs-8">
                                    <div className="select-wrapper">
                                        <select name="nearestHospital" value={this.state.nearestHospital} onChange={this.handleInputChange}>
                                            <option value="" disabled hidden>Valitse sinua lähin Pohjola Sairaalan toimipiste</option>
                                            <option value="helsinki">Helsinki</option>
                                            <option value="kuopio">Kuopio</option>
                                            {/* <option value="lappeenranta">Lappeenranta</option> */}
                                            <option value="oulu">Oulu</option>
                                            {/* <option value="pori">Pori</option> */}
                                            <option value="tampere">Tampere</option>
                                            <option value="turku">Turku</option>
                                            
                                            
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="row checkboxes">
                                <div className="col-xs-12">
                                    <span className={this.state.valid.email ? '' : 'error'}>
                                        <input type="checkbox" name="agreeTerms" id="checkbox-rules" value={this.state.agreeTerms} onChange={this.handleInputChange} />
                                        <label htmlFor="checkbox-rules">Olen yli 15-vuotias ja hyväksyn kilpailun <a href="#" onClick={this.handleRules}>säännöt</a>*</label>
                                        {/* <label htmlFor="checkbox-rules">Olen yli 15-vuotias ja hyväksyn kilpailun <a href="#" onClick={this.handleRules}>säännöt</a> sekä <a href="#" onClick={this.handleTerms}>rekisteriselosteen</a>*</label> */}
                                    </span>
                                </div>
                                {/* <div className="col-xs-12">
                                    <input type="checkbox" name="agreeMoreInfo" id="checkbox-more-info-posa" value={this.state.agreeMoreInfo} onChange={this.handleInputChange} />
                                    <label htmlFor="checkbox-more-info-posa">Haluan saada lisätietoja ja tarjouksia Pohjola Terveys Oy:ltä ja sen rajatuilta kumppaneilta</label>
                                </div> */}
                                <div className="col-xs-12 terms-texts">
                                    <p>Henkilötietoja käytetään arvonnan suorittamiseen ja voittajien tavoittamiseen. Kampanjaan liittyvästä henkilötietojen käsittelystä tietoa löytyy <a href="#" onClick={this.handleTerms}>tietosuojaselosteesta</a></p>
                                    <p>Lisätietoa henkilötietojen käsittelystä Pohjola Sairaalassa löytyy osoitteesta <a href="https://www.pohjolasairaala.fi/fi/tietoa-meista/tietosuojaseloste" target="_blank">pohjolasairaala.fi/tietoa-meista/tietosuojaseloste</a> </p>
                                </div>
                                
                            </div>
                            <div className="submit-container">
                                <button className="btn btn-green btn-half" onClick={(e) => {e.preventDefault(); this.handleSubmit(); }}>Osallistu</button>
                            </div>

                            <div className="errorText" style={{visibility: this.state.valid.all ? 'hidden' : 'visible'}}>
                                Tarkista pakolliset kentät
                            </div>
                        </form>
                    </div>
                </div>
            </article>
            </div>
            </div>

        );
    }
} 

export default withRouter(Form);


// WEBPACK FOOTER //
// ./src/app/components/views/Form.js